import React from 'react'

const FAQsComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default FAQsComponent
